import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextareaAutosize,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuItemMui from "@mui/material/MenuItem";
import timezone from "dayjs/plugin/timezone";
import { useContext, useEffect, useState } from "react";
import Header from "../../components/Header";
import { Grid2 } from "@mui/material";
import { Apartment, SaveAlt, TextSnippet } from "@mui/icons-material";
import { tokens } from "../../theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import NotificationToaste from "../global/NotificationToaste";
import dayjs, { utc } from "dayjs";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import { setPayload, setPostPayload, setPutPayload } from "../../services/api";
import CementBlocksDetails from "./CementBlocksDetails";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const CementBlocks = ({
  data,
  handleClose,
  selectedTest,
  setOpenReportDialog,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [authUsers, setAuthUsers] = useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [loading, setLoading] = useState(true);
  const [update, setUpdate] = useState(false);
  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const [eachTest, setEachTest] = useState({
    serialNo: "AUTO",
    dateOfCast: "",
    dateOfTest: "",
    weight: "",
    concreteMixtureArray: "",
    areaOfCube: "",
    compressiveStrength: "",
  });

  // console.log("this is data ..0", selectedTest);
  // console.log("this is data ..1", data);

  const [mainData, setMainData] = useState({
    date: dayjs(new Date()).format("YYYY-MM-DD"),
    institute: data.institute,
    reference: "",
    sampleLocation: "",
    cement: "",
    grade: "",
    concreteMixture: "",
    areaOfCube: "22500",
    dateOfCast: dayjs(new Date()).format("YYYY-MM-DD"),
    dateOfTest: dayjs(new Date()).format("YYYY-MM-DD"),
    testDays: "",
    labTestsDataFromSubs: [],
    specialNote:
      "The test results reported herein relate to the specimens submitted to material testing laboratory & we do not certify the quality of a product / site in general.",
    remarks: "",
    reportType: "CBLOCK",
    sampleTakenBy: "",
    testedBy: { id: "" },
    reportedBy: loggedUser,
    authorizedBy: null,
    labRequest: data,
    barcode: "",
    labRequestTests: selectedTest,
    referenceReportNumber: "",
    reportTypeCount: "",
    dateOfSiteVisit: "",
    interlockType: "",
    height: "",
  });

  const [selectedLabel, setSelectedLabel] = useState("");

  const options = [
    {
      value: "format1",
      label:
        "The test results reported  herein related to the specimens submitted to material testing laboratory & we do not certify the quality of a product / site in general.",
    },
    {
      value: "format2",
      label:
        "The test results reported herein relate to the specimens taken by the officer of material testing laboratory & we do not certify the quality of a product / site in general.",
    },
  ];

  const handleRadioChange = (event) => {
    const selectedValue = event.target.value;
    const selectedOption = options.find((opt) => opt.value === selectedValue);
    setMainData((pre) => ({
      ...pre,
      specialNote: selectedOption.label,
    }));
  };

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    loadBasicData();
    return () => loadBasicData();
  }, []);

  const loadBasicData = async () => {
    // console.log("selectedid ", selectedTest.id);
    setLoading(true);
    await axios
      .get(DATA_SAVE_URL + "/api/v1/dataForm/reportData/" + data.id, {
        params: {
          testId: selectedTest.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function (response) {
        // console.log("tada", response.data);
        if (response.data.labTestFormData !== null) {
          setUpdate(true);
          setMainData(response.data.labTestFormData);
        } else {
          addCubesToTable();
        }

        setAuthUsers(response.data.authUsers);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
      });
    setLoading(false);
  };

  const addCubesToTable = () => {
    // console.log("data qty " + selectedTest.quantity);
    const newItems = Array.from({ length: selectedTest.quantity }, (_, i) => ({
      serialNo: selectedTest.startingSerialNo + i,
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: mainData.areaOfCube,
      weight: "",
      compressiveStrength: "",
      concreteMixture: mainData.concreteMixture,
    }));
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: newItems,
    }));
  };

  const handleSaveData = async () => {
    if (mainData.testedBy.id === "") {
      setMessage("Select tested by user..!");
      setMessageType("warning");
      setOpen(true);
      return;
    }

    if (!update) {
      setLoading(true);
      console.log("main data save ", mainData);
      console.log("logged user ", loggedUser);
      const sendObject = {
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestsDataFromSubs: mainData.labTestsDataFromSubs,
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "CBLOCK",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData?.testedBy.id },
        reportedBy: { id: loggedUser.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: "",
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
        dateOfSiteVisit: mainData.dateOfSiteVisit,
        interlockType: mainData.interlockType,
        height: mainData.height,
      };

      await setPostPayload
        .setPayloadData("/dataForm/saveReport", sendObject)
        .then(function (response) {
          // console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          handleClose();
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    } else {
      setLoading(true);
      // console.log("main data ", mainData);
      setMainData((pre) => ({
        ...pre,
        id: data.id,
      }));

      const sendObject = {
        id: mainData.id,
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestsDataFromSubs: mainData.labTestsDataFromSubs,
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "CBLOCK",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: loggedUser.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: mainData.barcode,
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
        dateOfSiteVisit: mainData.dateOfSiteVisit,
        interlockType: mainData.interlockType,
        height: mainData.height,
      };

      await setPutPayload
        .setPayloadData("/dataForm/updateReport", sendObject)
        .then(function (response) {
          // console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 0 0 0",
        margin: "0 0 0 0",
      }}
    >
      {mainData.rejectReason === null || mainData.rejectReason === "" ? (
        ""
      ) : (
        <Stack sx={{ width: "100%", marginBottom: "5px" }}>
          <Alert severity="error" width="100%">
            <AlertTitle>This report is rejected.</AlertTitle>
            Reason : {mainData?.rejectReason}
          </Alert>
        </Stack>
      )}
      <Paper
        sx={{
          padding: "10px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header title="COMPRESSIVE STRENGTH TEST" subtitle="GENERAL DATA" />
        <Box>
          <Grid2 container spacing={1}>
            <Grid2 size={8}>
              <Paper elevation={2} sx={{ padding: "10px" }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <TextSnippet />
                      <Typography variant="h5">PROJECT</Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.project}
                    </Typography>
                  </Grid2>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <Apartment />
                      <Typography variant="h5" component="h2">
                        INSTITUTE NAME
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.institute.instituteName}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Reference"
                      value={mainData.reference}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          reference: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Sample Locations"
                      value={mainData.sampleLocation}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          sampleLocation: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Report Reference Number"
                      value={mainData.referenceReportNumber}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          referenceReportNumber: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
            <Grid2 size={4}>
              <Paper elevation={2} sx={{ padding: "10px", height: "100%" }}>
                <Grid2 container>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT NUMBER</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {update
                        ? "QC/" +
                          mainData.reportType +
                          "/" +
                          mainData.labRequest.year +
                          "/" +
                          String(mainData.reportTypeCount).padStart(4, "0")
                        : "AUTO"}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">JOB NO</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {data.year + "/" + String(data.id).padStart(4, "0")}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT DATE</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center" justifyItems="center">
                    <Box sx={{ width: "200px" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker"]}
                          sx={{ paddingTop: "8px" }}
                        >
                          <DatePicker
                            label="Date of report"
                            size="small"
                            format="YYYY-MM-DD"
                            timezone="Asia/Colombo"
                            value={
                              mainData.date
                                ? dayjs(mainData.date).tz("Asia/Colombo", true)
                                : dayjs(new Date()).tz("Asia/Colombo", true)
                            }
                            onChange={(newValue) => {
                              const colomboTime = newValue?.tz(
                                "Asia/Colombo",
                                true,
                              );
                              setMainData((pre) => ({
                                ...pre,
                                date: dayjs(colomboTime).format("YYYY-MM-DD"),
                              }));
                            }}
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Box>
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
          </Grid2>
        </Box>
      </Paper>
      <Paper
        sx={{ borderRadius: "8px", padding: "10px", width: "100%" }}
        elevation={3}
      >
        <Header
          title="TESTING OF CEMENT BLOCKS DETAILS"
          subtitle="ENTER TESTING DATA"
        />
        <Divider sx={{ margin: "10px 0px 10px 0" }} />
        <CementBlocksDetails
          mainData={mainData}
          setMainData={setMainData}
          isNonMobile={isNonMobile}
        />
      </Paper>
      {loading ? (
        <CircularProgress
          sx={{
            color: colors.greenAccent[500],
            position: "absolute",
            zIndex: 10,
          }}
        />
      ) : (
        ""
      )}
      <Paper
        sx={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          marginTop: "20px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header title="TEST NOTES" subtitle="AUTHORIZE DATA" />
        <Divider />
        <FormControl>
          <FormLabel id="demo-row-radio-buttons-group-label">
            Special Note text formats
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            onChange={handleRadioChange}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
          <div style={{ marginTop: 2 }}>
            <strong>Selected Label:</strong> {selectedLabel}
          </div>
        </FormControl>
        <Grid2 container spacing={1} marginTop="10px">
          <Grid2 size={12}>
            <FormHelperText id="textarea-helper-text">
              Special Note
            </FormHelperText>
            <TextareaAutosize
              placeholder="Special Notes"
              value={mainData.specialNote}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  specialNote: e.target.value,
                }))
              }
              minRows={3}
              maxRows={3}
              style={{
                width: "100%",
                resize: "none",
              }}
            />
          </Grid2>
          <Grid2 size={12}>
            <FormHelperText id="textarea-helper-text">Remarks</FormHelperText>
            <TextareaAutosize
              placeholder="Remarks"
              aria-describedby="textarea-helper-text"
              value={mainData.remarks}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  remarks: e.target.value,
                }))
              }
              minRows={2}
              maxRows={2}
              fullWidth
              style={{ width: "100%", resize: "none", padding: "1px" }}
            />
          </Grid2>
          <Grid2 size={7}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Sample taken / supplied by"
              value={mainData.sampleTakenBy}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  sampleTakenBy: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={5}>
            <TextField
              select
              label="Tested by"
              fullWidth
              size="small"
              defaultValue=""
              value={mainData.testedBy.id}
              onChange={(e) => {
                e.preventDefault();
                setMainData((pre) => ({
                  ...pre,
                  testedBy: {
                    ...pre.testedBy,
                    id: e.target.value,
                  },
                }));
              }}
            >
              {authUsers.map((data) => (
                <MenuItemMui key={data.id} value={data.id}>
                  {data.firstName + " " + data.lastName}
                </MenuItemMui>
              ))}
            </TextField>
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Divider sx={{ width: "100%" }} />
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              color="secondary"
              loading={loading}
              startIcon={<SaveAlt />}
              variant="contained"
              onClick={handleSaveData}
            >
              Save Data
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

export default CementBlocks;
